import Dashboard from '../components/Dashboard/Dashboard';

const Admin = () => {
  return <Dashboard />;
};

export default Admin;
